<template>
  <div>
    <h2>线路图</h2>
    <div class="flex-right">
      <Button type="primary" @click="save">保存</Button>
    </div>
    <img class="main-img" :src="data.url || noImg" alt="" />
    <div class="console">
      <Upload
        class="upload-btn"
        :action="uploadUrl"
        :on-success="uploadMainPic"
        :format="['jpg', 'jpeg', 'png', 'gif']"
        :max-size="5120"
        :on-format-error="handleFormatError"
        :show-upload-list="false"
        :on-exceeded-size="handleMaxSize"
      >
        <Button icon="ios-cloud-upload-outline">上传图片</Button>
      </Upload>
    </div>
  </div>
</template>

<script>
let urlPrefix = process.env.VUE_APP_URL;
import noImg from "@/assets/imgs/no-img.png";
export default {
  data() {
    return {
      uploadUrl:
        urlPrefix + "/file/imgUpload?token=" + this.$store.getters.token,
      data: {},
      noImg: noImg,
    };
  },
  methods: {
    async getData() {
      try {
        let res = await this.api({
          url: "/scheme/getMasterPlan",
          method: "get",
          errorAlert: false,
          params: {
            token: this.$store.getters.token,
            ttoken: this.$store.getters.ttoken,
            student_id: this.$store.getters.selectedStudent._id,
          },
        });
        this.data = res;
      } catch (error) {
        console.log("运行到这");
        this.data = {};
      }
    },

    uploadMainPic(res) {
      this.data.url = res.url;
    },

    handleFormatError(file) {
      this.$Notice.warning({
        title: "该文件格式错误",
        desc: file.name + "格式不正确,请选择png,jpg,jpeg,gif格式",
      });
    },

    handleMaxSize(file) {
      this.$Notice.warning({
        title: "文件大小才超出5M",
        desc: file.name + "文件大小超出5M,请选择5M以下的文件",
      });
    },

    async save() {
      await this.api({
        url: "scheme/saveMasterPlan",
        method: "post",
        params: {
          token: this.$store.getters.token,
          ttoken: this.$store.getters.ttoken,
        },
        data: {
          student_id: this.$store.getters.selectedStudent._id,
          url: this.data.url,
        },
      });

      this.$Message.success("更新成功");
    },
  },
  mounted() {
    if (!this.$store.getters.selectedStudent._id) {
      return;
    }
    this.getData();
  },
  watch: {
    "$store.getters.selectedStudent": function () {
      this.getData();
    },
  },
};
</script>

<style lang="less" scoped>
h2 {
  font-size: 24px;
  font-weight: bolder;
}

.upload-btn {
  display: block;
  margin: auto;
}

.main-img {
  width: 450px;
  height: auto;
  display: block;
  margin: auto;
}
.console {
  display: flex;
  align-items: center;
  margin-top: 20px;
}
</style>